import TableComponent from "../../components/organism/Table/TableComponent";
import { FC, useMemo, useState } from "react";
import { Center } from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";
import { CellProps, Column } from "react-table";
import { useNavigate } from "react-router-dom";
import SwitchComponent from "../../components/atom/Switch/SwitchComponent";
import { primaryColor } from "../../utils/colors";
import AlertDialogComponent from "../../components/molecule/AlertDialog/AlertDialogComponent";
import { AuthUser } from "../../types/User/AuthUser";

interface TableUsersProps {
  dataTable: any[];
  isLoaded: boolean;
  user: AuthUser;
  handleStateChange: (id: number, isActive: boolean) => void;
}

const TableUsers: FC<TableUsersProps> = ({
  dataTable,
  isLoaded,
  user,
  handleStateChange,
}) => {
  const navigate = useNavigate();

  const [isSwitchDialogOpen, setIsSwitchDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<{
    id: number;
    isActive: boolean;
  } | null>(null);

  const onSwitchToggle = (id: number, isActive: boolean) => {
    if (isActive) {
      setSelectedUser({ id, isActive });
      setIsSwitchDialogOpen(true);
    } else {
      handleStateChange(id, isActive);
    }
  };

  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      { Header: "Nome", accessor: "name" },
      { Header: "Email", accessor: "email" },
      { Header: "Nº de telemóvel", accessor: "phoneNumber" },
      { Header: "Perfil", accessor: "roles[0].name" },
      { Header: "Entidade", accessor: "organization.name" },
      { Header: "Província", accessor: "userProvince.name" },
      { Header: "Município", accessor: "userCounty.name" },
      {
        Header: "Estado",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <SwitchComponent
            isActive={row.original.isActive}
            onChange={() =>
              onSwitchToggle(row.original.id, row.original.isActive)
            }
            value={row.original.id}
            color={primaryColor}
          />
        ),
      },
    ];

    if (user?.permissions && user.permissions.includes("EditUser")) {
      baseColumns.push({
        Header: "Gerir",
        accessor: "edit",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <Center justifyContent="flex-end">
            <EditIcon
              color={primaryColor}
              boxSize={6}
              mr="10px"
              cursor="pointer"
              onClick={() => {
                navigate(`/utilizadores/${row.original.id}`, {
                  state: { edit_user: row.original },
                });
              }}
            />
          </Center>
        ),
      });
    }

    return baseColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.permissions, navigate, handleStateChange]);

  return (
    <>
      <TableComponent
        isLoaded={isLoaded}
        columns={columns}
        data={dataTable}
        fixedColumnIds={[{ value: "edit", hasShadow: true }]}
      />
      {selectedUser && selectedUser.isActive && (
        <AlertDialogComponent
          isOpen={isSwitchDialogOpen}
          setIsOpen={setIsSwitchDialogOpen}
          title="Inativar Utilizador"
          text={
            <>
              Tem a certeza que deseja inativar o utilizador? <br />
              Após esta ação, o utilizador não conseguirá aceder ao sistema.
            </>
          }
          handleButton={() => {
            handleStateChange(selectedUser.id, selectedUser.isActive);
            setIsSwitchDialogOpen(false);
          }}
          buttonText="Inativar"
        />
      )}
    </>
  );
};

export default TableUsers;
